const replaceUrlParams = (template, parameters) => {
    return template.replace(/{([^{}]+)}/g, (_, parameterName) => {
        if (parameterName in parameters) {
            return parameters[parameterName];
        }
        throw new Error(`Failed to replace URL parameters in '${template}', no URL parameter was provided for '${parameterName}'`);
    });
};
const appendQueryParams = (baseUrl, parameters) => {
    const params = Object.entries(parameters)
        .filter(([, parameterValue]) => parameterValue !== undefined && (!Array.isArray(parameterValue) || parameterValue.length > 0))
        .map(([parameterName, parameterValue]) => {
        if (Array.isArray(parameterValue)) {
            return parameterValue.map(value => `${parameterName}=${value}`).join('&');
        }
        else {
            return `${parameterName}=${parameterValue}`;
        }
    })
        .join('&');
    return params.length > 0 ? `${baseUrl}?${params}` : baseUrl;
};
export const formatUrl = (relativeUrl, baseUrl = '', urlParameters = {}, queryParameters) => {
    relativeUrl = replaceUrlParams(relativeUrl, urlParameters);
    if (queryParameters) {
        relativeUrl = appendQueryParams(relativeUrl, queryParameters);
    }
    if (relativeUrl.startsWith('/')) {
        relativeUrl = relativeUrl.slice(1);
    }
    if (baseUrl.length > 0 && !baseUrl.endsWith('/')) {
        baseUrl = `${baseUrl}/`;
    }
    return new URL(baseUrl + relativeUrl).toString();
};
//# sourceMappingURL=format-url.js.map